import React from "react";
import { Link } from "react-router-dom";
import appointmentService from "../../../services/appointment.service";
import { toast } from "react-toastify";

function AppointmentListItem({ appt, isSelected, onCheckChange }) {
  const SentType = ["Not Sent", "Email", "SMS", "Call", "Live Call"];
  const ConfirmedMessage = [
    "Not Confirmed",
    "Confirmed by Eyeconx",
    "Confirmed by PMS",
    "Cancelled",
  ];

  const status = appt.appointmentStatus || {};
  const patient = appt.patient || {};
  const doctor = appt.doctor || {};

  const reminderData = [
    { label: "Prebooked", date: status.datePrebooked, type: status.prebookedSentType, active: status.isPrebooked },
    { label: "First", date: status.dateFirst, type: status.firstSentType, active: status.isFirst },
    { label: "Second", date: status.dateSecond, type: status.secondSentType, active: status.isSecond },
    { label: "Last", date: status.dateLast, type: status.lastSentType, active: status.isLast },
    { label: "Same Day", date: status.dateSameDay, type: status.sameDaySentType, active: status.isSameDay },
  ];

  const handleCheckbox = (e) => onCheckChange(appt.id, e.target.checked);

  const handleConfirmCancel = (apptId, type) => {
    appointmentService
      .updateAppointmentStatus(appt.clinicId, apptId, type)
      .then(() => toast.success("Appointment updated successfully"))
      .catch(() => toast.error("Failed to update appointment"));
  };

  const confirmedLabel = ConfirmedMessage[appt.isConfirmed] || "Unknown";

  const confirmedBadgeClass =
    appt.isConfirmed === 1
      ? "bg-success"
      : appt.isConfirmed === 2
      ? "bg-primary"
      : appt.isConfirmed === 3
      ? "bg-danger"
      : "bg-secondary";

  return (
    <tr className="align-middle">
      {/* Checkbox */}
      <td>
        <input
          type="checkbox"
          className="form-check-input"
          checked={isSelected}
          onChange={handleCheckbox}
        />
      </td>

      {/* Time */}
      <td>
        <div className="d-flex flex-column">
          <span className="fw-semibold">
            {appt.startTime} - {appt.endTime}
          </span>
          <small className="text-muted">
            <span className={`badge ${confirmedBadgeClass} bg-opacity-75 me-1`}>
              {confirmedLabel}
            </span>
          </small>
        </div>
      </td>

      {/* Main content */}
      <td>
        <div className="d-flex flex-column">

          {/* Patient + Doctor + Reminders */}
          <div className="d-flex justify-content-between align-items-start">

            <div>
              {/* ⭐ CLICKABLE PATIENT NAME */}
              <Link
                to={`/patient-files/${appt.patientId}`}
                className="fw-bold text-primary text-decoration-none hover-underline"
              >
                {patient.firstName} {patient.lastName}
              </Link>

              {patient.preferredName && (
                <span className="text-muted"> ({patient.preferredName})</span>
              )}

              <div>
                <small className="text-muted">
                  Doctor: {doctor.firstName} {doctor.lastName}
                </small>
              </div>
            </div>

            {/* Reminders */}
            <div className="d-flex gap-2">
              {reminderData.map((r, idx) => (
                <i
                  key={idx}
                  className={`bi bi-alarm fs-5 ${
                    r.active ? "text-success" : "text-secondary opacity-50"
                  }`}
                  data-bs-toggle="tooltip"
                  title={
                    r.date
                      ? `${r.label} reminder sent on ${r.date} via ${
                          SentType[r.type] || "Unknown"
                        }`
                      : `${r.label} reminder not sent`
                  }
                ></i>
              ))}
            </div>
          </div>

          {/* Contact details */}
          <div className="mt-2 text-muted small d-flex flex-wrap gap-3">
            {patient.email && (
              <span>
                <i className="bi bi-envelope-fill me-1"></i>
                {patient.email}
              </span>
            )}
            {patient.phoneNumber && (
              <span>
                <i className="bi bi-telephone-fill me-1"></i>
                {patient.phoneNumber}
              </span>
            )}
            {patient.cellNumber && (
              <span>
                <i className="bi bi-phone-fill me-1"></i>
                {patient.cellNumber}
              </span>
            )}
          </div>

          {/* Type & Reason */}
          <div className="mt-1 text-muted small">
            <div>Type: {appt.type || "N/A"}</div>
            <div>Reason: {appt.reason || "N/A"}</div>
          </div>
        </div>
      </td>

      {/* Actions */}
      <td className="text-end">
        {appt.isConfirmed === 0 && (
          <button
            className="btn btn-sm btn-outline-success mb-2"
            onClick={() => handleConfirmCancel(appt.id, "CONFIRM")}
          >
            <i className="bi bi-check2-circle me-1"></i>
            Confirm
          </button>
        )}

        <div className="dropdown">
          <button
            className="btn btn-sm btn-light dropdown-toggle"
            data-bs-toggle="dropdown"
          >
            More
          </button>
          <div className="dropdown-menu dropdown-menu-end shadow-sm p-2">
            <button
              className="dropdown-item text-success fw-semibold"
              onClick={() => handleConfirmCancel(appt.id, "CONFIRM")}
            >
              <i className="bi bi-check2-circle me-2"></i>Confirm Appointment
            </button>
            <button
              className="dropdown-item text-danger fw-semibold"
              onClick={() => handleConfirmCancel(appt.id, "CANCEL")}
            >
              <i className="bi bi-x-circle me-2"></i>Cancel Appointment
            </button>
          </div>
        </div>
      </td>
    </tr>
  );
}

export default AppointmentListItem;
